import { Component } from '@angular/core';
import { ConfirmationData } from './confirmation-data.model';
import { ConfirmationModalService } from './confirmation-modal.service';
import { ConfirmationAction } from './confirmation-action.model';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { AlertComponent } from '../alert/alert.component';
import { AbstractSigaleComponent } from '../abstract-sigale.component';
import { isNotNullOrUndefined, isNullOrUndefined } from '../../utils/functions';

@Component({
	standalone: true,
	selector: 'confirmation-modal-component',
	templateUrl: './confirmation-modal.component.html',
	styleUrls: ['./confirmation-modal.component.scss'],
	imports: [
		CommonModule,
		FormsModule,
		TranslateModule,
		ButtonModule,
		DialogModule,
		ConfirmDialogModule,
		AlertComponent
	]
})
export class ConfirmationModalComponent extends AbstractSigaleComponent {

	confirmationData: ConfirmationData;
	visible = false;
	loading = false;

	constructor(private confirmationService: ConfirmationModalService) {
		super();
	}

	onClick(action: ConfirmationAction): void {
		this.loading = true;
		action._onClick.next();
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.confirmationService.ouvertureModal().subscribe((confirmationData) => {
			this.confirmationData = confirmationData;
			this.visible = true;
		});
		this.confirmationService.fermetureModal().subscribe(() => {
			this.loading = false;
			this.visible = false;
		});
	}

	afficherAlerteSimple(): boolean {
		return isNullOrUndefined(this.confirmationData?.alertData?.nomBouton1);
	}

	afficherAlerteAvecUnBouton(): boolean {
		return isNotNullOrUndefined(this.confirmationData?.alertData?.nomBouton1) && isNullOrUndefined(this.confirmationData?.alertData?.nomBouton2);
	}

	afficherAlerteAvecDeuxBoutons(): boolean {
		return isNotNullOrUndefined(this.confirmationData?.alertData?.nomBouton1) && isNotNullOrUndefined(this.confirmationData?.alertData?.nomBouton2);
	}
}
